// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-button_icon__Iew7h","hover-styling":"icon-button_hover-styling__oda7s","dropdown":"icon-button_dropdown__e8K_5"};